module.exports = __webpack_public_path__ + "static/media/snm-masala.a6832971.png";